import React, { useContext, useEffect } from "react";
import { BookSessionContext } from "@context/BookSessionContext";
import { PromoContext } from "@context/PromoContext";
import AlertMessage from "@components/AlertMessage";

const CapRedemptionsAlert = () => {
    const { selectedItems } = useContext(BookSessionContext);
    const { standardPromoCode, selectedPromo, reUseLimitReached, setReuseLimitReached } = useContext(PromoContext);

    const redemptionCount = selectedPromo?.promo_reuse_count ?? 0;
    const redemptionLimit = selectedPromo?.reuse_limit ?? 0;

    const totalTickets = selectedItems.reduce((acc, cur) => {
        return cur.type === "ticket" ? acc + cur.quantity : acc;
    }, 0);

    useEffect(() => {
        if (selectedPromo && selectedPromo?.cap_purchases) {
            const isLimitReached = redemptionCount + totalTickets > redemptionLimit;
            setReuseLimitReached(standardPromoCode ? false : isLimitReached);
        }
    }, [standardPromoCode, selectedItems, selectedPromo]);

    if ((!selectedPromo || selectedPromo?.cap_purchases === false) || standardPromoCode) {
        return null;
    }

    return (
        <>
            {reUseLimitReached ? (
                <AlertMessage
                    message={`Only ${redemptionLimit} voucher${redemptionLimit === 1 ? "" : "s"} can be purchased each calendar month.`}
                    type="error"
                />
            ) : null}
        </>
    );
};

export default CapRedemptionsAlert;
